// extracted by mini-css-extract-plugin
export default {"container":"oxa-z","oos":"pxa-z","selected":"qxa-z","recommendedSize":"rxa-z"};